import '../styles/pages/Personalisation.scss'
import first from '../assets/first1.svg'
import second from '../assets/middle1.svg'
import third from '../assets/middle2.svg'
import fourth from '../assets/perso.svg'
import fifth from '../assets/bottom1.svg'
import sixth from '../assets/bottom2.svg'
import arrow from '../assets/arrow.svg'
import { useEffect, useState } from 'react'
import { CiCamera } from "react-icons/ci";
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { SERVER } from '../hooks/config';

const Personalisation = () => {
    const navigate = useNavigate();
    const [quantity, setQuantity] = useState(1);
    const location = useLocation();
    const { id } = location.state || {}
    const [categories, setCategories] = useState([])
    const [product, setProduct] = useState(null);
    const [matieres, setMatieres] = useState([])
    const [formData, setFormData] = useState({
        modele: '',
        matiere: '',
        message: '',
        referencePhoto: null
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({ categories: false, matieres: false, product: false, images: false });
    const [persoImages, setPersoImages] = useState({
        first: null,
        second: null,
        third: null,
        fourth: null,
        fifth: null,
        sixth: null
    });

    useEffect(() => {
        fetchData()
        fetchMatieres()
        fetchPersoImages();
    }, []);

    const fetchMatieres = async () => {
        try {
            setLoading(true)
            setError(prev => ({ ...prev, matieres: false }));
            const modelsResponse = await axios.get(`${SERVER}/personalization-matiere`)
            setMatieres(modelsResponse.data)
        } catch (error) {
            console.error('Error fetching models:', error)
            setError(prev => ({ ...prev, matieres: true }));
        } finally {
            setLoading(false)
        }
    }

    const fetchData = async () => {
        try {
            setLoading(true)
            setError(prev => ({ ...prev, categories: false }));
            const categoriesResponse = await axios.get(`${SERVER}/categories`)
            setCategories(categoriesResponse.data)
        } catch (error) {
            console.error('Error fetching data:', error)
            setError(prev => ({ ...prev, categories: true }));
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (id) {
            fetchProduct(id);
        }
        fetchPersoImages();
    }, [id]);

    const fetchProduct = async (productId) => {
        try {
            setLoading(true);
            setError(prev => ({ ...prev, product: false }));
            const response = await axios.get(`${SERVER}/products/${productId}`);
            const productData = response.data;
            setProduct(productData);
            setFormData(prev => ({
                ...prev,
                modele: productData.category_name?.trim() || ''
            }));
        } catch (error) {
            console.error("Error fetching product:", error);
            setError(prev => ({ ...prev, product: true }));
        } finally {
            setLoading(false);
        }
    };
    
    const fetchPersoImages = async () => {
        try {
            setError(prev => ({ ...prev, images: false }));
            const response = await axios.get(`${SERVER}/personalisation/getImages`);
            setPersoImages(response.data);
        } catch (error) {
            console.error('Error fetching personalisation images:', error);
            setError(prev => ({ ...prev, images: true }));
        }
    };

    // Helper function to get image source
    const getImageSrc = (serverImage, fallbackImage) => {
        return serverImage ? `${SERVER}${serverImage}` : fallbackImage;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        setFormData(prev => ({
            ...prev,
            referencePhoto: e.target.files[0]
        }));
    };

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            let photoBase64 = null;
            if (formData.referencePhoto) {
                photoBase64 = await convertToBase64(formData.referencePhoto);
            }

            const personalizedItem = {
                product_id: id ? id : null,
                product_name: `Article personnalisé - ${formData.modele} (${formData.matiere})`,
                product_price: 0,
                quantity: quantity,
                total_price: 0,
                customizations: {
                    modele: formData.modele,
                    matiere: formData.matiere,
                    message: formData.message,
                    hasReferencePhoto: !!formData.referencePhoto
                }
            };

            localStorage.setItem('personalizedOrder', JSON.stringify({
                items: [personalizedItem],
                subtotal: 0,
                isPersonalized: true,
                referencePhoto: photoBase64,
                orderNotes: `Commande personnalisée:\n- Modèle: ${formData.modele}\n- Matière: ${formData.matiere}\n- Message: ${formData.message}\n- Photo de référence: ${formData.referencePhoto ? 'Oui' : 'Non'}`
            }));

            navigate('/checkout');

        } catch (error) {
            console.error('Error processing personalized order:', error);
            alert('Une erreur s\'est produite. Veuillez réessayer.');
        } finally {
            setLoading(false);
        }
    };

    return(
        <div className="personalisation">
            <div className='personalisation-title'>
                Articles personnalisés
            </div>
            <div className='personalisation-main'>
                {window.innerWidth > 768 ? (
                    <>
                        <div className='perso-intro'>
                            <div className='intro-content'>
                                <h2> Personnalisez vos accessoires offrez un souvenir unique </h2>
                                <span> 
                                    Avec Michkette.tn, vous pouvez aller encore plus{window.innerWidth > 768 ? <br /> : ' '}loin : personnaliser votre création pour qu'elle{window.innerWidth > 768 ? <br /> : ' '}devienne le reflet d'un souvenir, d'un prénom, d'une{window.innerWidth > 768 ? <br /> : ' '}couleur préférée.{window.innerWidth > 768 ? <br /> : ' '}Parce qu'offrir du fait-main, c'est offrir du vrai et y{window.innerWidth > 768 ? <br /> : ' '}ajouter votre touche personnelle, c'est offrir un{window.innerWidth > 768 ? <br /> : ' '}trésor.
                                </span>
                            </div>
                            <div className='intro-images'>
                                {window.innerWidth > 768 ? <img src={getImageSrc(persoImages.first, first)} alt='first image' className='first-image' /> : ''}
                            </div>
                        </div>
                        <div className='perso-intro'>
                            <div className='intro-content-2'>
                                <h2> Votre histoire mérite<br/>d'être racontée à<br/>travers un bijou ou<br/>un accessoire unique. </h2>
                                <img src={arrow} alt='arrow' />
                            </div>
                            <div className='intro-images'>
                                <img src={getImageSrc(persoImages.second, second)} alt='second image' className='second-image' />
                                <img src={getImageSrc(persoImages.third, third)} alt='third image' className='third-image' />
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className='perso-intro'>
                            <div className='intro-content'>
                                <h2> Personnalisez vos accessoires offrez un souvenir unique </h2>
                                <span> 
                                    Avec Michkette.tn, vous pouvez aller encore plus{window.innerWidth > 768 ? <br /> : ' '}loin : personnaliser votre création pour qu'elle{window.innerWidth > 768 ? <br /> : ' '}devienne le reflet d'un souvenir, d'un prénom, d'une{window.innerWidth > 768 ? <br /> : ' '}couleur préférée.{window.innerWidth > 768 ? <br /> : ' '}Parce qu'offrir du fait-main, c'est offrir du vrai et y{window.innerWidth > 768 ? <br /> : ' '}ajouter votre touche personnelle, c'est offrir un{window.innerWidth > 768 ? <br /> : ' '}trésor.
                                </span>
                            </div>
                            <div className='intro-images'>
                                <img src={getImageSrc(persoImages.first, first)} alt='first image' className='first-image' />
                            </div>
                        </div>
                        <div className='perso-intro'>
                            <div className='intro-images'>
                                <img src={getImageSrc(persoImages.second, second)} alt='second image' className='second-image' />
                                <img src={getImageSrc(persoImages.third, third)} alt='third image' className='third-image' />
                            </div>
                            <div className='intro-content-2'>
                                <h2> Votre histoire mérite<br/>d'être racontée à<br/>travers un bijou ou<br/>un accessoire unique. </h2>
                                <img src={arrow} alt='arrow' />
                            </div>
                        </div>
                    </>
                )}
                <div className='perso-style'>
                    <div className='perso-style-content'>
                        <h2> Personnalisez </h2>
                        <h3> votre création </h3>
                        <img src={getImageSrc(persoImages.fourth, fourth)} alt='fourth image' />
                    </div>
                    <div className='perso-style-func'>
                        {error.product && id ? (
                            <div className="perso-error-message">
                                <p>Impossible de charger les informations du produit.</p>
                                <button onClick={() => fetchProduct(id)} className="retry-button">Réessayer</button>
                            </div>
                        ) : error.categories || error.matieres ? (
                            <div className="perso-error-message">
                                <p>Impossible de charger les options de personnalisation.</p>
                                <button onClick={() => { fetchData(); fetchMatieres(); }} className="retry-button">Réessayer</button>
                            </div>
                        ) : (
                            <form className='personalisation-form' onSubmit={handleSubmit}>
                            {id && product && (
                                <div className="personalisation-form-section">
                                    <h2>Personnalisez : {product.fullname}</h2>
                                </div>
                            )}
                            <div className='form-group'>
                                <label>Modèle</label>
                                <select 
                                    className='form-select'
                                    name='modele'
                                    value={formData.modele}
                                    onChange={handleInputChange}
                                    required
                                    disabled={!!id}
                                    >
                                    <option value=''>Sélectionnez un modèle</option>
                                    {categories?.map((category) => (
                                        <option key={category.id} value={category.name}>
                                            {category.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            
                            <div className='form-group'>
                                <label>Matière</label>
                                <select 
                                    className='form-select'
                                    name='matiere'
                                    value={formData.matiere}
                                    onChange={handleInputChange}
                                    required
                                >
                                    <option value=''>Sélectionnez une matière</option>
                                    {matieres?.map((matiere) => (
                                        <option key={matiere.id} value={matiere.name}>
                                            {matiere.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            
                            <div className='form-group'>
                                <label>Quantité</label>
                                <div className='quantity-controls'>
                                    <button type='button' className='quantity-btn minus' disabled={quantity === 1} onClick={() => {if (quantity !== 1) setQuantity(quantity-1)}}>-</button>
                                    <span> {quantity} </span>
                                    <button type='button' className='quantity-btn plus' onClick={() => setQuantity(quantity + 1)}>+</button>
                                </div>
                            </div>
                            
                            <div className='form-group'>
                                <label>Votre message</label>
                                <textarea 
                                    className='form-textarea' 
                                    placeholder="Écrire le Texte à graver"
                                    rows='4'
                                    name='message'
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    required
                                ></textarea>
                            </div>
                            
                            <div className='form-group'>
                                <label>Mettre une photo de référence (optionnel)</label>
                                <div className='file-upload-area'>
                                    <input 
                                        type='file' 
                                        className='file-input' 
                                        accept='image/*' 
                                        onChange={handleFileChange}
                                    />
                                    <div className='upload-placeholder'>
                                        <span className='camera-icon'><CiCamera /></span>
                                        {formData.referencePhoto ? (
                                            <span className='file-name'>{formData.referencePhoto.name}</span>
                                        ) : (
                                            <span>Cliquez pour ajouter une photo</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            
                            <button type='submit' className='submit-btn' disabled={loading}>
                                {loading ? 'Traitement...' : 'Passez votre commande'}
                            </button>
                        </form>
                        )}
                    </div>
                </div>
                <div className='perso-bottom'>
                    <div className='perso-bottom-images'>
                        <img src={getImageSrc(persoImages.fifth, fifth)} alt='fifth image' />
                        <img src={getImageSrc(persoImages.sixth, sixth)} alt='sixth image' />
                    </div>
                    <div className='perso-bottom-content'>
                        <h2> Personnaliser nos créations avec un </h2>
                        <h3> texte ou une image gravée </h3>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Personalisation;